import { AppLanguage, IUfinetSelectOption } from 'ufinet-web-functions'

export class ReportClassification {
	reportClassificationId: string
	nameEs: string
	nameEn: string
	namePt: string

	constructor(id: string, nameEs: string, nameEn: string, namePt: string) {
		this.reportClassificationId = id
		this.nameEs = nameEs
		this.nameEn = nameEn
		this.namePt = namePt
	}

	static mapReportClassificationToSelectOption(self: ReportClassification, language: AppLanguage): IUfinetSelectOption {
		return {
			label: language === 'es' ? self.nameEs : language === 'en' ? self.nameEn : self.namePt,
			value: self.reportClassificationId,
		}
	}
}
